import RootStore from './RootStore';

export let store: RootStore;

export const initStore = () => {
  store = new RootStore();
};
